import TomSelectBaseController from "./tom_select_base";

export default class extends TomSelectBaseController {
  get tomSelectOptions() {
    return {
      plugins: {
        clear_button: {
          title: "Remove all selected options",
          html: function (data) {
            return `<div class="${data.className}" title="${data.title}">&#65368;</div>`;
          },
        },
      },
      render: {
        optgroup_header: function (data, escape) {
          return `<div class="optgroup-header"><button type="button" data-action="click->tom-select#clickHeader"> ${data.label}</button></div>`;
        },
      },
    };
  }

  clickHeader(event) {
    event.preventDefault();
  }
}
